import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const TitleProject = ({ title }) => {
    return(
        <Grid item xs={12}>
            <Typography variant="h5">{title}</Typography>
        </Grid>
    );
}

export default TitleProject;